import _ from 'lodash';
import {loadDataAction,loadDataDoneAction} from 'modules/app/actions';
import {httpError} from 'modules/app/actions';

/**
 * @CoreConcept(name="Redux Middleware", description="This is a good Redux middleware example. If an action contains a promise then
 * success and fail actions are dispatched after the promise is resolved")
 * @deprecated This middleware is migrated to the reqres middleware. See the dashboard page actions for usage example
 */
export default (store) => (next) => (action) => {
    const { promise, types, appLoader, ...rest } = action;
    if (!promise) {
        return next(action);
    }

    const [REQUEST, SUCCESS, FAILURE] = types;

    next({ ...rest, type: REQUEST });

    if (appLoader) {
        next(loadDataAction(appLoader));
    }
    let realPromise = promise.constructor.name === 'Promise' ? promise : promise();

    return realPromise
        .then((result) => {
            if (appLoader) {
                next(loadDataDoneAction(appLoader));
            }
            if (_.isString(SUCCESS)) {
                next({ ...rest, payload:result, type: SUCCESS });
            }
            else if (_.isArray(SUCCESS)) {
                for (let actionType of SUCCESS) {
                    console.log(actionType);
                    next(_.isObject(actionType) ? actionType : { ...rest, payload:result, type: actionType });
                }
            }
        })
        .catch((error) => {
            if (appLoader) {
                next(loadDataDoneAction(appLoader));
            }
            if (error.response && error.response.status === 401) {
                next(httpError.http401(error,action));
            }
            if (error.body) {
                next({ ...rest, payload: {body:error.body, ...error}, type: FAILURE });
            } else {
                next({ ...rest, error, type: FAILURE });
            }
        });

};
